import { combineReducers } from 'redux';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import { CrmRecord, CrmSettings } from '../../model';
import { Actions, StoreState } from '../types';

function contacts(state: CrmRecord[] | null = null, action: Actions): CrmRecord[] | null {
  switch (action.type) {
    case getType(actions.setCrmContacts):
      return action.payload

    default:
      return state
  }
}

function settings(state: CrmSettings = {
  defaultCrmPage: '',
  defaultNoContactResultPage: '',
  integrationEnabled: false,
  handleCallBacks: false,
  handleDirectCalls: false,
  popContactBehaviour: 'Auto',
  popContactEvent: 'None',
  popOutgoing: false,
  popPhoneCall: false,
}, action: Actions): CrmSettings {
  switch (action.type) {
    case getType(actions.setCrmSettings):
      return action.payload

    default:
      return state
  }
}

export default combineReducers({
  contacts,
  settings,
})

export function selectCrmContacts(state: StoreState) {
  return state.crmIntegration.contacts
}

export function selectCrmSettings(state: StoreState) {
  return state.crmIntegration.settings
}
